import { useEffect } from "react";

interface ApiParams {
  countryCode?: string;
  tld?: string;
  [key: string]: any;
}

interface CollectorConfig {
  apiParams?: ApiParams;
  setApiParams?: (params: ApiParams) => void;
}

interface Option {
  text: string | undefined;
  value: string | undefined;
}

export const useFilteredApiParams = (
  collectorConfig: CollectorConfig | null,
  countryCodesToShow: Option[] | undefined,
  domainsToShow: Option[]
) => {
  // used on load.
  useEffect(() => {
    if (!collectorConfig?.apiParams || !collectorConfig?.setApiParams) return;

    const { countryCode, tld, ...restApiParams } = collectorConfig.apiParams;

    let ccExists = undefined;
    if(countryCodesToShow) {
        ccExists = countryCodesToShow.some((cc) => cc.text === countryCode);
    }

    const tldExists = domainsToShow.some((cc) => cc.text === tld);

    const updatedApiParams: ApiParams = {
      ...restApiParams,
      ...(ccExists && { countryCode }),
      ...(tldExists && { tld }),
    };

    // Only update when a parameter actually changed — avoids a setState/effect loop.
    const current = collectorConfig.apiParams;
    const keys = new Set([ ...Object.keys(current), ...Object.keys(updatedApiParams) ]);
    const changed = Array.from(keys).some((key) => current[key] !== updatedApiParams[key]);
    if (changed) {
      collectorConfig.setApiParams(updatedApiParams);
    }
    // eslint-disable-next-line
  }, [ collectorConfig, countryCodesToShow, domainsToShow ]);
};
